module.exports = __webpack_public_path__ + "img/dep_computerphoneandelectronics@3x.2cc450c6.png";